import { React, useRef, useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Lightbox from 'yet-another-react-lightbox';
import { Counter } from 'yet-another-react-lightbox/plugins';
import 'yet-another-react-lightbox/plugins/counter.css';
import 'yet-another-react-lightbox/styles.css';
import { getImageSrc } from '../../utils';
import ImageCheckFallback from './ImageCheckFallback';
const Carousel = ({ dataSlide, dataName, dataSlideDefault }) => {
    let sliderRef = useRef(null);
    const [pausePlay, setPausePlay] = useState(true);
    const [activeSlide, setActiveSlide] = useState(0);

    // lightbox
    const [openLightbox, setOpenLightbox] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);

    const play = () => {
        sliderRef.slickPlay();
        setPausePlay(!pausePlay);
    };
    const pause = () => {
        sliderRef.slickPause();
        setPausePlay(!pausePlay);
    };
    const next = () => {
        console.log('aaa');

        sliderRef.slickNext();
    };
    const previous = () => {
        sliderRef.slickPrev();
    };
    const settings = {
        dots: false,
        infinite: dataSlide && dataSlide?.length > 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        beforeChange: (current, next) => {
            setActiveSlide(next);
        },
    };

    const handleImageClick = (index) => {
        pause();
        setLightboxIndex(index);
        setOpenLightbox(true);
    };

    const lightboxSlides =
        dataName === 'RecruitPage' && dataSlide
            ? dataSlide?.map((fileName) => ({
                  src: getImageSrc('recruit_photo', fileName),
                  alt: fileName || 'Recruit Image',
              }))
            : [];

    return (
        <div className={`slider-container ${dataSlideDefault === true ? 'slider-default' : ''}`}>
            <Slider ref={(slider) => (sliderRef = slider)} {...settings}>
                {dataName === 'Home' ? (
                    dataSlide && dataSlide?.length > 0 ? (
                        dataSlide?.map((item, index) => {
                            return (
                                <div
                                    key={`main-banner-${index}`}
                                    className={`carousel-item ${index === 0 ? 'active' : ''}`}
                                >
                                    <a
                                        href={item?.linkType === 'window' ? item?.linkWinName : item?.linkUrl}
                                        rel="nofollow"
                                        target={item?.linkType === 'window' ? '_self' : item?.linkType}
                                        onClick={(e) => {
                                            if (item?.linkType === 'window') {
                                                e.preventDefault();
                                                window.open(item?.linkWinName, '_blank', 'width=1200,height=1000');
                                            }
                                        }}
                                    >
                                        <ImageCheckFallback
                                            folderName={'banner_center_photo'}
                                            imgName={item?.imgNameMain}
                                            alt="DentalJob Slide"
                                        />
                                    </a>
                                </div>
                            );
                        })
                    ) : (
                        <div className="carousel-item">
                            <ImageCheckFallback
                                classImg="d-block w-100"
                                src="./images/PAAAA010/slide-2.png"
                                alt="DentalJob Slide"
                            />
                        </div>
                    )
                ) : dataName === 'RecruitPage' ? (
                    dataSlide &&
                    dataSlide?.length > 0 &&
                    dataSlide?.map((fileName, index) => (
                        <div key={index} onClick={dataSlideDefault ? undefined : () => handleImageClick(index)}>
                            <ImageCheckFallback
                                folderName={'recruit_photo'}
                                imgName={fileName}
                                alt={fileName ? fileName : ''}
                                classImg={`carousel-item ${index === 0 ? 'active' : ''}`}
                            />
                        </div>
                    ))
                ) : dataName === 'GrandSlide' ? (
                    dataSlide &&
                    dataSlide?.length > 0 &&
                    dataSlide?.map((item, index) => (
                        <a
                            key={`grand-banner-1-${index}`}
                            className={`carousel-item ${index === 0 ? 'active' : ''}`}
                            href={item?.linkType === 'window' ? item?.linkWinName : item?.linkUrl}
                            rel="nofollow"
                            target={item?.linkType === 'window' ? '_self' : item?.linkType}
                            onClick={(e) => {
                                if (item?.linkType === 'window') {
                                    e.preventDefault();
                                    window.open(item?.linkWinName, '_blank', 'width=1200,height=1000');
                                }
                            }}
                            style={{ height: '442px' }}
                        >
                            <ImageCheckFallback
                                classImg={dataName}
                                folderName={'banner_center_photo'}
                                imgName={item?.imgNameMain}
                                alt="DentalJob Slide"
                            />
                        </a>
                    ))
                ) : dataName === 'BizImage' ? (
                    dataSlide &&
                    dataSlide?.length > 0 &&
                    dataSlide?.map((fileName, index) => (
                        <div key={index} onClick={dataSlideDefault ? undefined : () => handleImageClick(index)}>
                            <ImageCheckFallback
                                folderName={'volunteer'}
                                imgName={fileName}
                                alt={fileName ? fileName : ''}
                                classImg={`carousel-item ${index === 0 ? 'active' : ''}`}
                            />
                        </div>
                    ))
                ) : (
                    ''
                )}
            </Slider>
            {dataSlide && dataSlide?.length > 1 && (
                <>
                    <button className="carousel-control-prev" type="button" onClick={previous}>
                        <span className="carousel-control-prev-icon" />
                    </button>
                    <button className="carousel-control-next" type="button" onClick={next}>
                        <span className="carousel-control-next-icon" />
                    </button>
                </>
            )}

            {dataName === 'Home' && (
                <div className="carousel-controller">
                    <div className="count-slides">
                        <div className="current-slide">{activeSlide + 1}</div>/
                        <div className="total-slides">{dataSlide ? dataSlide?.length : ''}</div>
                    </div>

                    <button className="carousel-control-prev" type="button" onClick={previous}>
                        <i className="icon icon-black-prev" />
                    </button>
                    {pausePlay ? (
                        <button className="carousel-control-pause" type="button">
                            <i className="icon icon-pause" onClick={pause} />
                        </button>
                    ) : (
                        <button className="carousel-control-play" type="button">
                            <i className="icon icon-play" onClick={play} />
                        </button>
                    )}
                    <button className="carousel-control-next" type="button" onClick={next}>
                        <i className="icon icon-black-next" />
                    </button>
                </div>
            )}
            {dataName === 'RecruitPage' && (
                <Lightbox
                    open={openLightbox}
                    close={() => {
                        setOpenLightbox(false);
                        play();
                    }}
                    slides={lightboxSlides}
                    index={lightboxIndex}
                    plugins={[Counter]}
                    carousel={{ finite: true, padding: '15%' }}
                    styles={{
                        container: {
                            backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        },
                    }}
                />
            )}
            {/* {dataName === 'GrandSlide' && (
                <>
                    <button className="carousel-control-prev" type="button">
                        <span className="carousel-control-prev-icon" onClick={previous} />
                    </button>
                    <button className="carousel-control-next" type="button">
                        <span className="carousel-control-next-icon" onClick={next} />
                    </button>
                </>
            )} */}
        </div>
    );
};
export default Carousel;
